import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import { GET_BRANCHES } from '../graphql/queries/branch.query';
import { CREATE_BRANCH, REMOVE_BRANCH_BY_ID, UPDATE_BRANCH } from '../graphql/mutation/branch.mutation';

@Injectable({
  providedIn: 'root'
})
export class BranchService {

  constructor(private apollo: Apollo) { }

  fetchBranches(search: string = ''): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_BRANCHES,
        variables: { search },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.branches || []));
  }

  createBranch(createBranchInput: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: CREATE_BRANCH,
      variables: {
        input: createBranchInput,
      },
    });
  }

  updateBranch(id: number, updateBranchInput: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: UPDATE_BRANCH,
      variables: {
        id,
        updateBranchInput
      },
    });
  }

    // Remove branch
    removeBranchById(id: number): Observable<any> {
      return this.apollo.use('accounts').mutate({
        mutation: REMOVE_BRANCH_BY_ID,
        variables: { id },
      });
    }
}
